<template>
	<button
	type="button"
	class="no-btn c-chart-preview st-chart-preview"

	@contextmenu.prevent="$refs.menu.open"
	@click="$emit('click')"
	:class="{'st-chart-preview--active': $route.params.chartid == data.id, 'st-chart-preview--child': child,'st-chart-preview--locked': locked, 'st-chart-preview--hidden': !visible,  'st-chart-preview--trashed': trashed, 'st-chart-preview--small': small }">
        <div class="st-chart-preview__img" :style="(backgroundImage ? 'background-image: url(' + backgroundImage + ')' : '')">
	        <div
			v-if="chart_component_exists('v-chart-' + chart.component) && $store.getters['features/livepreview']"
			style="pointer-events: none; position: absolute; top: 0; right: 0; left: 0; bottom: 0;"
			:preview="true"
			:is="'v-chart-' + chart.component"
			:data="chart"
			:key="chart.id"></div>
            <div class="st-chart-preview__wrap">
                <div class="st-chart-preview__alttext" v-if="!data.image">
                    <strong v-if="data.fields && data.fields.title">{{ data.fields.title.value }}</strong>
                    <strong v-else>{{ data.template }}</strong>
                </div>
            </div>
            <div v-if="!visible || trashed || locked || refreshing" class="st-chart-preview__overlay">
            	<div class="st-chart-preview__oicon" v-if="trashed">
            		<i class="fa fa-trash" aria-hidden="true"></i>
            	</div>
            	<div class="st-chart-preview__oicon" v-else-if="locked">
            		<i class="fa fa-lock" aria-hidden="true"></i>
            	</div>
            	<div class="st-chart-preview__oicon" v-else-if="!visible">
            		<i class="fa fa-eye-slash" aria-hidden="true"></i>
            	</div>
            	<div class="st-chart-preview__oicon" v-else-if="!refreshing">
            		<i class="fa fa-refresh" aria-hidden="true"></i>
            	</div>
            </div>
        </div>
        <vue-context ref="menu">
	        <ul>
	            <li
				v-if="(presentation.addablecharts && presentation.addablecharts.length > 0)"
				@click="$store.commit('START_ADDCHART', {
					position: chart.position
				})"
	            >{{ $t('new Slide') }}</li>
	            <li
				v-if="(chart.addablecharts && chart.addablecharts.length > 0)"
				@click="$store.commit('START_ADDCHART', {
					parent: chart.id
				})"
	            >{{ $t('new Child Slide') }}</li>
	            <li
	            v-if="!chart.visible && chart.permissions.can_change_visible && chart.permissions && chart.permissions.can_edit"
	            @click="$store.commit('TOGGLE_CHART_VISIBILITY', chart.id)"
	            >{{ $t('show Chart') }}</li>
	            <li
	            v-if="chart.visible && chart.permissions.can_change_visible && chart.permissions && chart.permissions.can_edit"
				@click="$store.commit('TOGGLE_CHART_VISIBILITY', chart.id)"
	            >{{ $t('hide Chart') }}</li>
	            <li
	            class="delete"
				v-if="chart.permissions.can_delete && chart.permissions && chart.permissions.can_edit"
				@click="$store.commit('TOGGLE_CHART_TRASHED', chart.id)"
	            >{{ $t('delete Chart') }}</li>
	        </ul>
    	</vue-context>
    </button>
</template>

<script>

import { VueContext } from 'vue-context';

export default {
	name: 'c-chart-preview',
	 components: {
        VueContext
    },

	computed: {
		backgroundImage(){
			return this.$store.getters.getBackgroundImageByChartId(this.data.id);
		},
		presentation(){
			return this.$store.getters.presentation;
		},
		chart(){
			return this.$store.getters.getChartById(this.data.id);
		},
	},

	props: {
		data: {
			type: Object,
			default: function(){
				return {};
			}
		},


		child: {
			type: Boolean,
			default: false
		},

		small: {
			type: Boolean,
			default: false
		},

		visible: {
			type: Boolean,
			default: true
		},

		onlymaster: {
			type: Boolean,
			default: false
		},

		trashed: {
			type: Boolean,
			default: false
		},

		locked: {
			type: Boolean,
			default: false
		},
		refreshing: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		chart_component_exists(chartname){
			const ccexists = (this.$store.getters.chartcomponents.indexOf(chartname) >= 0);
			if(!ccexists) console.info('chart component dosent exists', chartname)
			return ccexists;
		},
	},
}
</script>

<style lang="scss">
	.v-context ul {
		padding: 0 !important;
	}
	.v-context ul li:hover {
		background: #0066cc !important;
	}
	.v-context ul li.delete:hover {
		background: #a3248f !important;
	}
	.st-chart-preview{
		$scope: &;
		&--hidden {

		}

		&--trashed {

		}

		&__overlay{
			color: #fff;
			background-color: rgba(#3E4C57, 0.8);
			position: absolute;
		    top: 2px;
		    left: 2px;
		    bottom: 2px;
		    right: 2px;
	    	display: flex;
		    align-items: center;
		    justify-content: center;
	    }

	    &__oicon {
	    	font-size: 1.5em;
	    	line-height: 1.9em;
	    	width: 2em;
	    	height: 2em;
	    	text-align: center;
	    	border: 2px solid rgba(#fff, 1);
	    }
	}
	.fade-enter-active, .fade-leave-active {
	  transition: opacity .3s
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	  opacity: 0
	}
</style>



// WEBPACK FOOTER //
// src/components/p-editor/c-chart-preview.vue